import React, { useEffect, useState } from "react";
import {
  Card, CardBody, Col, Container, Row, Modal, ModalHeader, ModalBody, ModalFooter,
  Button, Input, Label, FormGroup, Spinner, Alert
} from "reactstrap";

//Import Breadcrumb
import Breadcrumbs from "../../../components/Common/Breadcrumb";

const FaturalandirmaBilgileri = () => {
  document.title = "Faturalandırma Bilgileri | HarmanaGEL";

  // --- 1. KULLANICI VE ROL KONTROLLERİ ---
  const authUser = JSON.parse(localStorage.getItem("authUser") || "{}");
  const loggedInUserId = authUser?.ID;
  const isAdmin = authUser?.HESAP_TURU === 'Admin'; // 3: Admin

  // --- 2. ADMİN İÇİN KULLANICI SEÇİM STATE'LERİ ---
  const [targetUserId, setTargetUserId] = useState(loggedInUserId?.toString() || "");
  const [usersList, setUsersList] = useState([]);

  // --- STATE'LER ---
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(false);
  const [data, setData] = useState({ company: null, invoice: null, bank: null });

  const [modalVisible, setModalVisible] = useState(false);
  const [activeType, setActiveType] = useState("company"); // "company" | "invoiceSettings" | "bank"
  const [form, setForm] = useState({});

  const [alertConfig, setAlertConfig] = useState({ visible: false, message: "", type: "success" });

  const BASE_URL = "https://harmanagelapi.stechomeyazilim.info";

  // --- ADMİN İSE TÜM KULLANICILARI ÇEK (Dropdown İçin) ---
  useEffect(() => {
    if (isAdmin) {
      fetch(`${BASE_URL}/KULLANICILAR?$expand=HESAP_TURU`)
        .then(res => res.json())
        .then(data => setUsersList(data.value || []))
        .catch(err => console.error("Kullanıcı listesi alınamadı:", err));
    }
  }, [isAdmin]);

  // --- API ÇAĞRILARI (Veri Yükleme) ---
  const loadAllData = async () => {
    if (!targetUserId) return;
    setLoading(true);
    try {
      // 1. Şirket Bilgisi (Hedef Kullanıcıya Göre)
      const companyRes = await fetch(`${BASE_URL}/MAGAZALAR?$filter=KULLANICI_ID eq ${targetUserId}`);
      const companyData = await companyRes.json();
      const primaryCompany = companyData.value?.[0] || null;

      // 2. Banka Bilgisi (Hedef Kullanıcıya Göre)
      const bankRes = await fetch(`${BASE_URL}/FATURA_BILGILERI?$filter=KULLANICI_ID eq ${targetUserId}`);
      const bankData = await bankRes.json();
      const primaryBank = bankData.value?.[0] || null;

      // 3. Fatura Bilgisi (Şirkete Bağlı)
      let primaryInvoice = null;
      if (primaryCompany) {
        const invRes = await fetch(`${BASE_URL}/FATURA_BILGILERI?$filter=Users_Company_ID eq ${primaryCompany.ID}`);
        const invData = await invRes.json();
        primaryInvoice = invData.value?.[0] || null;
      }

      setData({ company: primaryCompany, bank: primaryBank, invoice: primaryInvoice });
    } catch (error) {
      console.error("Veri yüklenirken hata:", error);
      showAlert("Bilgiler yüklenirken bir hata oluştu.", "danger");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAllData();
  }, [targetUserId]);

  const showAlert = (message, type = "success") => {
    setAlertConfig({ visible: true, message, type });
    setTimeout(() => setAlertConfig({ visible: false, message: "", type: "success" }), 4000);
  };

  // --- MODAL AÇMA VE FORM DOLDURMA ---
  const openModal = (type) => {
    setActiveType(type);
    if (type === "company") {
      setForm({
        kdvNumber: data.invoice?.KdvNumber || "",
        vergiDairesi: data.invoice?.VergiDairesi || "",
        adres: data.invoice?.Adres || "",
        iban: data.invoice?.Iban || ""
      });
    } else if (type === "bank") {
      setForm({
        bankName: data.bank?.Users_BankAccount_BankName || "",
        holderName: data.bank?.Users_BankAccount_HolderName || "",
        iban: data.bank?.Users_BankAccount_Iban || ""
      });
    } else if (type === "invoiceSettings") {
      setForm({
        companyType: data.invoice?.Company_Type || "",
        eInvoiceId: data.invoice?.E_Invoice_ID || "",
        companyCapital: data.invoice?.Company_Capital || "",
        subjectToVat: data.invoice?.Subject_To_VAT || false,
        invoicingMandate: data.invoice?.Invoicing_Mandate || false
      });
    }
    setModalVisible(true);
  };

  // --- ŞİRKET YOKSA OTOMATİK OLUŞTURMA YARDIMCISI ---
  const ensureCompanyExists = async () => {
    if (data.company?.ID) return data.company.ID;

    // Şirket adını belirleme (Admin başkası adına oluşturuyorsa onun adını, yoksa kendi adını kullan)
    let newCompanyName = authUser?.AD_SOYAD || "Kullanıcı Firması";
    if (isAdmin && targetUserId !== loggedInUserId?.toString()) {
        const tUser = usersList.find(u => u.ID.toString() === targetUserId.toString());
        if (tUser) {
            newCompanyName = tUser.AD_SOYAD || tUser.Users_Name || "Kullanıcı Firması";
        }
    }

    // Kullanıcının firması yoksa arka planda oluştur
    const res = await fetch(`${BASE_URL}/MAGAZALAR`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        Users_Company_Name: newCompanyName,
        Company_OLUSTURMA_TARIHI: new Date().toISOString(),
        Users_ID: parseInt(targetUserId) // HEDEF KULLANICI ID'Sİ
      })
    });
    const newCompany = await res.json();
    return newCompany.ID;
  };

  // --- KAYDETME İŞLEMİ ---
  const handleSave = async () => {
    setActionLoading(true);
    try {
      // ŞİRKET BİLGİLERİ (Users_Invoince Tablosu)
      if (activeType === "company") {
        const companyId = await ensureCompanyExists();
        const payload = {
          KdvNumber: form.kdvNumber,
          VergiDairesi: form.vergiDairesi,
          Adres: form.adres,
          Iban: form.iban,
          Users_Company_ID: companyId
        };

        if (data.invoice) {
          await fetch(`${BASE_URL}/FATURA_BILGILERI(${data.invoice.ID})`, {
            method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
          });
        } else {
          await fetch(`${BASE_URL}/FATURA_BILGILERI`, {
            method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
          });
        }
      } 
      // BANKA BİLGİLERİ (Users_BankAccount Tablosu)
      else if (activeType === "bank") {
        const payload = {
          Users_BankAccount_BankName: form.bankName,
          Users_BankAccount_HolderName: form.holderName,
          Users_BankAccount_Iban: form.iban,
          Users_ID: parseInt(targetUserId) // HEDEF KULLANICI ID'Sİ
        };

        if (data.bank) {
          await fetch(`${BASE_URL}/FATURA_BILGILERI(${data.bank.ID})`, {
            method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
          });
        } else {
          await fetch(`${BASE_URL}/FATURA_BILGILERI`, {
            method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
          });
        }
      } 
      // FATURA AYARLARI (Users_Invoince Tablosu)
      else if (activeType === "invoiceSettings") {
        const companyId = await ensureCompanyExists();
        const payload = {
          Company_Type: form.companyType,
          E_Invoice_ID: form.eInvoiceId,
          Company_Capital: form.companyCapital,
          Subject_To_VAT: form.subjectToVat,
          Invoicing_Mandate: form.invoicingMandate,
          Users_Company_ID: companyId
        };

        if (data.invoice) {
          await fetch(`${BASE_URL}/FATURA_BILGILERI(${data.invoice.ID})`, {
            method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
          });
        } else {
          await fetch(`${BASE_URL}/FATURA_BILGILERI`, {
            method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload)
          });
        }
      }

      setModalVisible(false);
      showAlert("Bilgiler başarıyla kaydedildi.", "success");
      loadAllData(); // Verileri yenile
    } catch (e) {
      console.error(e);
      showAlert("İşlem sırasında bir sorun oluştu.", "danger");
    } finally {
      setActionLoading(false);
    }
  };

  // --- YARDIMCI BİLEŞENLER ---
  const InfoRow = ({ label, value }) => (
    <div className="d-flex justify-content-between align-items-center mb-3 pb-2 border-bottom">
      <span className="text-muted fw-bold text-uppercase font-size-11">{label}</span>
      <span className="text-dark fw-bold">{value || "Tanımlanmamış"}</span>
    </div>
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Hesabım" breadcrumbItem="Faturalandırma Bilgileri" />

          {/* SADECE ADMİNLER İÇİN KULLANICI SEÇİM ALANI */}
          {isAdmin && (
            <Row className="mb-4">
              <Col md={12} lg={8} xl={6}>
                <Card className="shadow-sm border border-info rounded-4 mb-0">
                  <CardBody className="py-3 px-4">
                    <Label className="fw-bold text-info mb-2 d-flex align-items-center">
                      <i className="mdi mdi-shield-account fs-4 me-2"></i> Admin Paneli: Kullanıcı Seçimi
                    </Label>
                    <Input 
                        type="select" 
                        value={targetUserId} 
                        onChange={(e) => setTargetUserId(e.target.value)} 
                        className="bg-soft-info border-info fw-bold text-dark cursor-pointer"
                    >
                      <option value={loggedInUserId}>Kendiniz ({authUser?.AD_SOYAD})</option>
                      {usersList.filter(u => u.ID !== loggedInUserId).map(u => (
                        <option key={u.ID} value={u.ID}>
                          {u.AD_SOYAD || u.Users_Name} - ({u.Users_Type?.Users_Type_Title || "Bilinmeyen Rol"})
                        </option>
                      ))}
                    </Input>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {/* ALERT BİLDİRİMİ */}
          <Alert isOpen={alertConfig.visible} color={alertConfig.type} className="border-0 shadow-sm font-size-15">
            <i className={`mdi ${alertConfig.type === "success" ? "mdi-check-circle" : "mdi-alert-circle"} me-2`}></i>
            {alertConfig.message}
          </Alert>

          {loading ? (
            <div className="text-center py-5">
              <Spinner color="primary" />
              <p className="mt-2 text-muted fw-medium">Bilgiler yükleniyor...</p>
            </div>
          ) : (
            <Row>
              {/* ŞİRKET BİLGİLERİ KARTI */}
              <Col lg="6">
                <Card className="shadow-sm border rounded-4">
                  <CardBody className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="card-title mb-0 fw-bold"><i className="mdi mdi-domain text-primary me-2 fs-4 align-middle"></i> Şirket Bilgileri</h5>
                      <Button color="light" size="sm" className="fw-bold" onClick={() => openModal("company")}>
                        <i className={`mdi ${data.invoice ? 'mdi-pencil' : 'mdi-plus'} text-primary me-1`}></i> 
                        {data.invoice ? "Düzenle" : "Ekle"}
                      </Button>
                    </div>
                    
                    <InfoRow label="KDV Numarası" value={data.invoice?.KdvNumber} />
                    <InfoRow label="Vergi Dairesi" value={data.invoice?.VergiDairesi} />
                    <InfoRow label="Fatura Adresi" value={data.invoice?.Adres} />
                    <InfoRow label="Fatura IBAN" value={data.invoice?.Iban} />
                  </CardBody>
                </Card>
              </Col>

              {/* FATURA AYARLARI KARTI */}
              <Col lg="6">
                <Card className="shadow-sm border rounded-4">
                  <CardBody className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="card-title mb-0 fw-bold"><i className="mdi mdi-information-outline text-primary me-2 fs-4 align-middle"></i> Fatura Ayarları</h5>
                      <Button color="light" size="sm" className="fw-bold" onClick={() => openModal("invoiceSettings")}>
                        <i className="mdi mdi-pencil text-primary me-1"></i> Düzenle
                      </Button>
                    </div>

                    <InfoRow label="Şirket Türü" value={data.invoice?.Company_Type} />
                    <InfoRow label="Şirket Sermayesi" value={data.invoice?.Company_Capital} />
                    <InfoRow label="KDV'ye Tabi" value={data.invoice?.Subject_To_VAT ? "EVET" : "HAYIR"} />
                    <InfoRow label="Faturalandırma Yetkisi" value={data.invoice?.Invoicing_Mandate ? "EVET" : "HAYIR"} />
                  </CardBody>
                </Card>
              </Col>

              {/* BANKA BİLGİLERİ KARTI */}
              <Col lg="12">
                <Card className="shadow-sm border rounded-4 mt-2">
                  <CardBody className="p-4">
                    <div className="d-flex justify-content-between align-items-center mb-4">
                      <h5 className="card-title mb-0 fw-bold"><i className="mdi mdi-bank text-primary me-2 fs-4 align-middle"></i> Banka Bilgileri</h5>
                      <Button color="light" size="sm" className="fw-bold" onClick={() => openModal("bank")}>
                        <i className={`mdi ${data.bank ? 'mdi-pencil' : 'mdi-plus'} text-primary me-1`}></i> 
                        {data.bank ? "Düzenle" : "Ekle"}
                      </Button>
                    </div>

                    <Row>
                      <Col md={4}><InfoRow label="Banka Adı" value={data.bank?.Users_BankAccount_BankName} /></Col>
                      <Col md={4}><InfoRow label="Hesap Sahibi" value={data.bank?.Users_BankAccount_HolderName} /></Col>
                      <Col md={4}><InfoRow label="IBAN" value={data.bank?.Users_BankAccount_Iban} /></Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          )}

          {/* DÜZENLEME MODALI */}
          <Modal isOpen={modalVisible} toggle={() => setModalVisible(false)} centered className="border-0">
            <ModalHeader toggle={() => setModalVisible(false)} className="bg-light border-bottom font-size-16 fw-bold">
              <i className="mdi mdi-square-edit-outline text-primary me-2"></i> Bilgileri Düzenle
            </ModalHeader>
            <ModalBody className="p-4 bg-white">
              
              {activeType === "company" && (
                <>
                  <FormGroup className="mb-3">
                    <Label className="text-muted fw-bold font-size-12 text-uppercase">KDV Numarası</Label>
                    <Input type="text" className="form-control-lg font-size-14" value={form.kdvNumber || ""} onChange={e => setForm({ ...form, kdvNumber: e.target.value })} placeholder="KDV Numarası girin" />
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label className="text-muted fw-bold font-size-12 text-uppercase">Vergi Dairesi</Label>
                    <Input type="text" className="form-control-lg font-size-14" value={form.vergiDairesi || ""} onChange={e => setForm({ ...form, vergiDairesi: e.target.value })} placeholder="Vergi Dairesi girin" />
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label className="text-muted fw-bold font-size-12 text-uppercase">Fatura Adresi</Label>
                    <Input type="textarea" className="form-control-lg font-size-14" rows="3" value={form.adres || ""} onChange={e => setForm({ ...form, adres: e.target.value })} placeholder="Tam adres girin" />
                  </FormGroup>
                  <FormGroup className="mb-4">
                    <Label className="text-muted fw-bold font-size-12 text-uppercase">Fatura IBAN</Label>
                    <Input type="text" className="form-control-lg font-size-14" value={form.iban || ""} onChange={e => setForm({ ...form, iban: e.target.value })} placeholder="TR..." />
                  </FormGroup>
                </>
              )}

              {activeType === "bank" && (
                <>
                  <FormGroup className="mb-3">
                    <Label className="text-muted fw-bold font-size-12 text-uppercase">Banka Adı</Label>
                    <Input type="text" className="form-control-lg font-size-14" value={form.bankName || ""} onChange={e => setForm({ ...form, bankName: e.target.value })} placeholder="Örn: Garanti BBVA" />
                  </FormGroup>
                  <FormGroup className="mb-3">
                    <Label className="text-muted fw-bold font-size-12 text-uppercase">Hesap Sahibi (Ad Soyad)</Label>
                    <Input type="text" className="form-control-lg font-size-14" value={form.holderName || ""} onChange={e => setForm({ ...form, holderName: e.target.value })} placeholder="Hesap sahibi adı" />
                  </FormGroup>
                  <FormGroup className="mb-4">
                    <Label className="text-muted fw-bold font-size-12 text-uppercase">IBAN</Label>
                    <Input type="text" className="form-control-lg font-size-14" value={form.iban || ""} onChange={e => setForm({ ...form, iban: e.target.value })} placeholder="TR..." />
                  </FormGroup>
                </>
              )}

              {activeType === "invoiceSettings" && (
                <>
                  <FormGroup className="mb-3">
                    <Label className="text-muted fw-bold font-size-12 text-uppercase">Şirket Türü</Label>
                    <Input type="text" className="form-control-lg font-size-14" value={form.companyType || ""} onChange={e => setForm({ ...form, companyType: e.target.value })} placeholder="Örn: Limited Şirketi" />
                  </FormGroup>
                  <FormGroup className="mb-4">
                    <Label className="text-muted fw-bold font-size-12 text-uppercase">Şirket Sermayesi</Label>
                    <Input type="text" className="form-control-lg font-size-14" value={form.companyCapital || ""} onChange={e => setForm({ ...form, companyCapital: e.target.value })} placeholder="Sermaye tutarı" />
                  </FormGroup>
                  
                  <div className="d-flex justify-content-between align-items-center mt-4 border-bottom pb-3">
                    <Label className="mb-0 fw-bold text-dark">KDV'ye Tabi</Label>
                    <div className="form-check form-switch form-switch-md mb-0">
                      <Input type="checkbox" className="form-check-input" checked={form.subjectToVat || false} onChange={e => setForm({ ...form, subjectToVat: e.target.checked })} />
                    </div>
                  </div>

                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <Label className="mb-0 fw-bold text-dark">Faturalandırma Yetkisi</Label>
                    <div className="form-check form-switch form-switch-md mb-0">
                      <Input type="checkbox" className="form-check-input" checked={form.invoicingMandate || false} onChange={e => setForm({ ...form, invoicingMandate: e.target.checked })} />
                    </div>
                  </div>
                </>
              )}

            </ModalBody>
            <ModalFooter className="bg-light border-top p-3">
              <Button color="secondary" outline className="fw-bold px-4" onClick={() => setModalVisible(false)} disabled={actionLoading}>Vazgeç</Button>
              <Button color="primary" className="fw-bold px-4 d-flex align-items-center" onClick={handleSave} disabled={actionLoading}>
                {actionLoading ? <Spinner size="sm" color="light" className="me-2" /> : <i className="mdi mdi-check-circle-outline me-2 fs-5"></i>}
                Bilgileri Kaydet
              </Button>
            </ModalFooter>
          </Modal>

        </Container>
      </div>
    </React.Fragment>
  );
};

export default FaturalandirmaBilgileri;